// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkPrint: React.FC<{ width?: number; height?: number; color1?: string; className?: string }> = ({
    width = undefined,
    height = undefined,
    color1 = "#e00b5a",
    className,
}) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 12 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M2.25 4.25H1.5V2c0-.827.673-1.5 1.5-1.5h5.379A1.5 1.5 0 0 1 9.44.938l.62.621a1.5 1.5 0 0 1 .439 1.062V4.25h-.75V2.621c0-.2-.08-.389-.22-.53l-.621-.62a.75.75 0 0 0-.53-.221H3a.75.75 0 0 0-.75.75zm8.25 1.5h-9a.75.75 0 0 0-.75.75v3h.75v-.75A.75.75 0 0 1 2.25 8h7.5a.75.75 0 0 1 .75.75v.75h.75v-3a.75.75 0 0 0-.75-.75m0 4.5v1.5a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75v-1.5H.75A.75.75 0 0 1 0 9.5v-3C0 5.673.673 5 1.5 5h9c.827 0 1.5.673 1.5 1.5v3a.75.75 0 0 1-.75.75zm-8.25-1.5v3h7.5v-3zm7.875-2.437a.563.563 0 1 1 0 1.125.563.563 0 0 1 0-1.125"
            />
        </svg>
    );
};

export default React.memo(LinkPrint);
